import { IRadiolabelTemplate } from "@services/http/repositories/Radiolabels.repository";

export enum ACTION_RADIOLABELS_TYPES {
  SET_RADIOLABELS = "SET_RADIOLABELS",
  DELETE_RADIOLABEL = "DELETE_RADIOLABEL",
  EDIT_RADIOLABEL = "EDIT_RADIOLABEL",
  ADD_RADIOLABEL = "ADD_RADIOLABEL",
}

export interface ActionRadiolabelsBase {
  type: ACTION_RADIOLABELS_TYPES;
  payload?: any;
}

export interface ActionSetRadiolabels extends ActionRadiolabelsBase {
  payload: IRadiolabelTemplate[];
}

export interface ActionDeleteRadiolabel extends ActionRadiolabelsBase {
  payload: number;
}

export interface ActionEditRadiolabel extends ActionRadiolabelsBase {
  payload: IRadiolabelTemplate;
}

export interface ActionAddRadiolabel extends ActionRadiolabelsBase {
  payload: IRadiolabelTemplate;
}
